// assets/js/photoswipe/gallery-photoswipe.js
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// import 'photoswipe/style.css'; // load once in your main entry

/**
 * Init PhotoSwipe for ONE gallery per page, scoped to a root element (Barba container).
 * @param {Element|Document} root
 */
export function initGalleryLightbox(root = document) {
    // Kill any previous instance (from the old Barba view)
    if (window.__dpage_pswp) {
        try { window.__dpage_pswp.destroy(); } catch { }
        window.__dpage_pswp = null;
    }

    // 🔎 Scope all queries to the current container
    const galleryEl = root.querySelector('.js-dpage-pswp');
    if (!galleryEl) return;

    // Prevent Barba navigation + blur for a11y
    const anchors = galleryEl.querySelectorAll('a[data-pswp-width], a[data-pswp-height], a[href]');
    anchors.forEach((a) => {
        a.setAttribute('data-barba-prevent', 'self');
        a.addEventListener('click', () => {
            if (document.activeElement === a) a.blur();
        }, true);
    });

    // ✅ Use the element, not a selector string
    const lightbox = new PhotoSwipeLightbox({
        gallery: galleryEl,                 // element scoping
        children: 'a[data-pswp-width]',     // your saved markup
        pswpModule: () => import('photoswipe'),
    });

    // If width/height missing on any anchor, fall back to the img's natural size
    lightbox.on('contentInit', (e) => {
        const { content } = e;
        const a = content.element;
        if (!a) return;
        if (!a.hasAttribute('data-pswp-width') || !a.hasAttribute('data-pswp-height')) {
            const img = a.querySelector('img');
            if (img && img.naturalWidth && img.naturalHeight) {
                a.setAttribute('data-pswp-width', img.naturalWidth);
                a.setAttribute('data-pswp-height', img.naturalHeight);
            }
        }
    });

    // Move focus into modal (a11y)
    lightbox.on('open', () => {
        requestAnimationFrame(() => {
            const modal = document.querySelector('.pswp');
            if (modal) {
                modal.setAttribute('tabindex', '-1');
                try { modal.focus({ preventScroll: true }); } catch { modal.focus(); }
            }
        });
    });

    lightbox.init();
    window.__dpage_pswp = lightbox;
}
